import { HubspotFunctionalityPayload, HubspotSingleEventPayload } from "@/@types/integrations";
import httpManager, { ResponseError } from "@/app/shared/utils/httpManager";

class HubspotManager {
  private resource = "/hubspot/";

  async getContactsExportableImportable(type = 'all', entity? = '', portfolio? = '') {
    try {
      const response = await httpManager.get(
        `${this.resource}clients/stats/?type=${type}&entity=${entity}&portfolio=${portfolio}`
      );
      console.log(response.data, "INTEGRATION RESPONSE");
      return response.data;
    } catch (error: any) {
      throw new ResponseError(error.response);
    }
  }

  async getHubspotConfig() {
    try {
      const response = await httpManager.get(`${this.resource}integration/config/`);

      console.log(response.data, "INTEGRATION RESPONSE");
      return response.data;
    } catch (error: any) {
      throw new ResponseError(error.response);
    }
  }

  async saveHubspotConfig(payload: HubspotFunctionalityPayload[]) {
    try {
      const response = await httpManager.post(
        `${this.resource}integration/config/`,
        payload
      );

      console.log(response.data, "INTEGRATION RESPONSE");
      return response.data;
    } catch (error: any) {
      throw new ResponseError(error.response);
    }
  }

  async saveHubspotEvent(payload: HubspotSingleEventPayload) {
    try {
      const response = await httpManager.post(
        `${this.resource}events/`,
        payload
      );

      console.log(response.data, "HUBSPOT EVENT RESPONSE");
      return response.data;
    } catch (error: any) {
      throw new ResponseError(error.response);
    }
  }

  async cancelHubspotEvent(id: number) {
    try {
      const response = await httpManager.post(
        `${this.resource}events/cancel/`,
        { event_id: id }
      );
      
      return response.data;
    } catch (error: any) {
      throw new ResponseError(error.response);
    }
  }
}

export const hubspotManager = new HubspotManager();
